<app-marketing-consent-modal
  [class.hidden]="!showMarketingConsentModal"
  [isSaving]="isSavingMarketingConsent"
  [errorMessage]="marketingConsentError"
  (accepted)="saveMarketingConsentDecision(true)"
  (declined)="saveMarketingConsentDecision(false)">
</app-marketing-consent-modal>

@if (!isProduction) {
  <div class="fixed top-0 left-0 z-50 bg-blue-500 text-white px-2 py-1 text-xs font-mono">
    <span class="sm:hidden">xs</span>
    <span class="hidden sm:inline md:hidden">sm</span>
    <span class="hidden md:inline lg:hidden">md</span>
    <span class="hidden lg:inline xl:hidden">lg</span>
    <span class="hidden xl:inline 2xl:hidden">xl</span>
    <span class="hidden 2xl:inline">2xl</span>
  </div>
}

<nav class="bg-white">
  <div class="app-navbar-grid grid grid-cols-24 lg:grid-cols-12 items-center">

    <div
      class="app-navbar-logo border-0 order-1 col-start-3 col-span-4 lg:col-start-2 lg:col-span-1">
      <a routerLink="/"
         class="items-center">
        <img src="logo-casato.svg"
             class="h-18"
             alt="Casato Logo"/>
      </a>
    </div>

    <div class="app-navbar-menu-toggle order-2 lg:order-2 col-span-4 sm:col-span-5 md:col-span-8 col-start-7 lg:col-start-3 lg:col-span-6 lg:ms-10  justify-center">
      <div class="block text-center">
        <button data-collapse-toggle="navbar-default"
                type="button"
                class="mx-auto block items-center p-3 h-12 lg:h-15 text-sm text-gray-500 rounded-md lg:hidden bg-gray-100 focus:ring-2 focus:outline-none focus:ring-gray-300"
                aria-controls="navbar-default"
                aria-expanded="false">
          <span class="sr-only">Open main menu</span>
          <svg class="w-6 h-6  lg:w-10 lg:h-10"
               aria-hidden="true"
               xmlns="http://www.w3.org/2000/svg"
               fill="none"
               viewBox="0 0 17 14">
            <path stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M1 1h15M1 7h15M1 13h15"/>
          </svg>
        </button>
      </div>
      <div class="block hidden w-full lg:block">
        <ul
          class="font-normal flex flex-col p-4 md:p-0 mt-4 border
                 border-gray-100 rounded-md bg-gray-50
                  md:flex-row md:space-x-8
                  rtl:space-x-reverse lg:mt-0 md:border-0 md:bg-white justify-center lg:justify-start">
          <li class="">
            <a href="/home"
               class="block py-2 px-3
            text-gray-900 rounded-sm lg:text-sm xl:text-base
            hover:bg-gray-100 md:hover:bg-transparent md:border-0
            md:hover:text-blue-700 md:p-0
            md:hover:bg-transparent text-center lg:text-left"
               aria-current="page">Home</a>
          </li>
          <li class="">
            <a routerLink="/busca"
               class="block py-2 px-3
            text-gray-900 rounded-sm lg:text-sm xl:text-base
            hover:bg-gray-100 md:hover:bg-transparent md:border-0
            md:hover:text-blue-700 md:p-0
            md:hover:bg-transparent text-center lg:text-left"
               aria-current="page">Buscar Imóveis</a>
          </li>
          @if (!isLoggedIn) {
            <li class="">
              <a routerLink="/planos"
                 class="block py-2 px-3
            text-gray-900 rounded-sm lg:text-sm xl:text-base
            hover:bg-gray-100 md:hover:bg-transparent md:border-0
            md:hover:text-blue-700 md:p-0
            md:hover:bg-transparent text-center lg:text-left"
                 aria-current="page">Planos</a>
            </li>
          }
          <li class="">
            <a routerLink="/artigos"
               class="block py-2 px-3
            text-gray-900 rounded-sm lg:text-sm xl:text-base
            hover:bg-gray-100 md:hover:bg-transparent md:border-0
            md:hover:text-blue-700 md:p-0
            md:hover:bg-transparent text-center lg:text-left"
               aria-current="page">Artigos</a>
          </li>
          <li class="">
            <a routerLink="sobre-nos"
               class="block py-2 px-3
            text-gray-900 rounded-sm lg:text-sm xl:text-base
            hover:bg-gray-100 md:hover:bg-transparent md:border-0
            md:hover:text-blue-700 md:p-0
            md:hover:bg-transparent text-center lg:text-left"
               aria-current="page">Sobre nós</a>
          </li>
          <!--          <li class="">-->
          <!--            <a href="#"-->
          <!--               class="block py-2 px-3-->
          <!--            text-gray-900 rounded-sm lg:text-sm xl:text-base-->
          <!--            hover:bg-gray-100 md:hover:bg-transparent md:border-0-->
          <!--            md:hover:text-blue-700 md:p-0-->
          <!--            md:hover:bg-transparent text-center lg:text-left "-->
          <!--               aria-current="page">Perguntas Frequentes</a>-->
          <!--          </li>-->
          <li class="">
            <a routerLink="/contato"
               class="block py-2 px-3
            text-gray-900 rounded-sm lg:text-sm xl:text-base
            hover:bg-gray-100 md:hover:bg-transparent md:border-0
            md:hover:text-blue-700 md:p-0
            md:hover:bg-transparent text-center lg:text-left"
               aria-current="page">Contato</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="app-navbar-actions order-3 lg:order-3 col-span-12 sm:col-span-11 md:col-span-8 col-end-23 lg:col-span-3 lg:my-10">
      <div class="block md:w-auto">
        <ul class="font-normal flex  p-4 md:p-0 flex-row rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white justify-end lg:justify-end">
          @if (isLoggedIn) {
            <li class="me-0">
              <a routerLink="favoritos"
                 class="block py-2 px-3 text-gray-900 rounded-sm hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 text-center"
                 aria-current="page">
                <svg class="w-6 h-6 text-gray-800 inline-block"
                     aria-hidden="true"
                     xmlns="http://www.w3.org/2000/svg"
                     width="24"
                     height="24"
                     fill="none"
                     viewBox="0 0 24 24">
                  <path stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12.01 6.001C6.5 1 1 8 5.782 13.001L12.011 20l6.23-7C23 8 17.5 1 12.01 6.002Z"/>
                </svg>
                Favoritos
              </a>
            </li>
            <button id="dropdownHoverButton"
                    data-dropdown-toggle="dropdownHover"
                    data-dropdown-trigger="click"
                    class="me-0 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-md text-gray-900 px-2 py-2 text-center inline-flex items-center justify-center hover:cursor-pointer"
                    type="button">
                    Minha conta
              <svg class="w-2.5 h-2.5 ms-3"
                   aria-hidden="true"
                   xmlns="http://www.w3.org/2000/svg"
                   fill="none"
                   viewBox="0 0 10 6">
                <path stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"/>
              </svg>
            </button>
            <!-- Dropdown menu -->
            <div id="dropdownHover"
                 class="z-10 hidden bg-white divide-y divide-gray-100 rounded-md shadow-sm w-44 ">
              <ul class="py-2 text-sm text-gray-700"
                  aria-labelledby="dropdownHoverButton">
                <li>
                  <a routerLink="minha-conta"
                     [queryParams]="{ tab: 'perfil' }"
                     class="text-gray-600  block px-4 py-2 hover:bg-gray-600 hover:text-white">Meus dados e plano</a>
                </li>
              </ul>
              <ul class="py-2 text-sm text-gray-700"
                  aria-labelledby="dropdownHoverButton">
                <li>
                  <a routerLink="minha-conta"
                     [queryParams]="{ tab: 'notificacoes' }"
                     class="text-gray-600  block px-4 py-2 hover:bg-gray-600 hover:text-white">Notificações</a>
                </li>
              </ul>
              <ul class="py-2 text-sm text-gray-700 "
                  aria-labelledby="dropdownHoverButton">
                <li>
                  <a (click)="signOut()"
                     class="text-gray-600 block px-4 py-2 hover:bg-gray-600 hover:text-white cursor-pointer">Sair</a>
                </li>
              </ul>
            </div>
          } @else {
            <li class="me-0">
              <a class="py-2 px-3
                      text-gray-900 rounded-sm text-xs lg:text-sm lg:font-medium
                      hover:bg-gray-100 hover:bg-transparent border-0
                      hover:text-blue-700 text-center"
                 routerLink="login"
                 aria-current="page">Login
              </a>
            </li>
            <li class="me-0 justify-center text-center lg:text-right">
              <a routerLink="planos"
                 class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-md
                  px-3 py-2 text-xs px-5 py-2.5 sm:px-5 sm:py-2.5 me-2 mb-2 text-center sm:text-sm sm:font-medium">Teste grátis</a>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-12 items-center">
    <div class="col-span-12">
      <div id="navbar-default"
           class="hidden w-full lg:hidden">
          <ul class="font-normal flex flex-col p-4 md:p-0 mt-4 border
                   border-gray-100 rounded-md bg-gray-50
                    md:flex-row md:space-x-8
                    rtl:space-x-reverse lg:mt-0 md:border-0 md:bg-white justify-center lg:justify-start">
            <li>
              <a routerLink="/"
                 class="block py-2 px-3 text-gray-900 rounded-sm hover:bg-gray-100 md:border-0 md:hover:text-blue-700 md:p-0  md:hover:bg-transparent text-center lg:text-left"
                 aria-current="page">Home</a>
            </li>
            <li>
              <a routerLink="/busca"
                 class="block py-2 px-3
              text-gray-900 rounded-sm
              hover:bg-gray-100 md:border-0
              md:hover:text-blue-700 md:p-0
              md:hover:bg-transparent text-center lg:text-left"
                 aria-current="page">Buscar Imóveis</a>
            </li>
            @if (!isLoggedIn) {
              <li>
                <a routerLink="/planos"
                   class="block py-2 px-3
              text-gray-900 rounded-sm
              hover:bg-gray-100 md:border-0
              md:hover:text-blue-700 md:p-0
              md:hover:bg-transparent text-center lg:text-left"
                   aria-current="page">Planos</a>
              </li>
            }
            <li>
              <a routerLink="/artigos"
                 class="block py-2 px-3
              text-gray-900 rounded-sm
              hover:bg-gray-100 md:border-0
              md:hover:text-blue-700 md:p-0
              md:hover:bg-transparent text-center lg:text-left"
                 aria-current="page">Artigos</a>
            </li>
            <li>
              <a routerLink="/sobre-nos"
                 class="block py-2 px-3
              text-gray-900 rounded-sm
              hover:bg-gray-100 md:border-0
              md:hover:text-blue-700 md:p-0
              md:hover:bg-transparent text-center lg:text-left"
                 aria-current="page">Sobre nós</a>
            </li>
            <!--            <li>-->
            <!--              <a href="#"-->
            <!--                 class="block py-2 px-3-->
            <!--              text-gray-900 rounded-sm-->
            <!--              hover:bg-gray-100 md:hover:bg-transparent md:border-0-->
            <!--              md:hover:text-blue-700 md:p-0-->
            <!--              md:hover:bg-transparent text-center lg:text-left"-->
            <!--                 aria-current="page">Perguntas Frequentes</a>-->
            <!--            </li>-->
            <li>
              <a routerLink="/contato"
                 class="block py-2 px-3
              text-gray-900 rounded-sm
              hover:bg-gray-100 md:hover:bg-transparent md:border-0
              md:hover:text-blue-700 md:p-0
              md:hover:bg-transparent text-center lg:text-left"
                 aria-current="page">Contato</a>
            </li>
          </ul>
      </div>
        </div>
    </div>
</nav>

<router-outlet></router-outlet>

<footer class="bg-gray-900 border-t border-gray-900">
  <div class="pt-20  grid grid-cols-1 md:grid-cols-12">
    <div class=" col-span-1  md:col-start-2 md:col-span-10">
      <div class="grid grid-cols-1 md:grid-cols-10">
        <div class="col-span-1 md:col-span-4 gap-4 flex flex-col">
          <a routerLink="/home"
             (click)="scrollToTop()"
             class="text-center md:text-start text-gray-500 text-base font-normal font-['Inter'] ">Home</a>
          <a routerLink="/busca"
             (click)="scrollToTop()"
             class="text-center md:text-start text-gray-500 text-base font-normal font-['Inter']">Buscar Imóveis</a>
          @if (!isLoggedIn) {
            <a routerLink="/planos"
               (click)="scrollToTop()"
               class="text-center md:text-start text-gray-500 text-base font-normal font-['Inter']">Planos</a>
          }
          <a routerLink="/artigos"
             (click)="scrollToTop()"
             class="text-center md:text-start text-gray-500 text-base font-normal font-['Inter']">Artigos</a>
          <a routerLink="/sobre-nos"
             (click)="scrollToTop()"
             class="text-center md:text-start text-gray-500 text-base font-normal font-['Inter']">Sobre nós</a>
          <a routerLink="/contato"
             (click)="scrollToTop()"
             class="text-center md:text-start text-gray-500 text-base font-normal font-['Inter']">Contato</a>
          @if (!isLoggedIn) {
            <a routerLink="/login"
               (click)="scrollToTop()"
               class="text-center md:text-start text-gray-500 text-base font-normal font-['Inter']">Login</a>
          } @else {
            <a routerLink="/usuario"
               (click)="scrollToTop()"
               class="text-center md:text-start text-gray-500 text-base font-normal font-['Inter']">Minha Conta</a>
          }
        </div>
        <div class="col-span-1 mt-8 md:mt-0 md:col-span-2 gap-4 md:col-end-11 flex flex-col">
          <a routerLink="/termos-e-condicoes"
             (click)="scrollToTop()"
             class="text-center md:text-end text-gray-500 text-base font-normal font-['Inter']"
             target="_blank"
          >
            Termos e Condições
          </a>
          <a routerLink="/politica-de-privacidade"
             (click)="scrollToTop()"
             class="text-center md:text-end text-gray-500 text-base font-normal font-['Inter']"
             target="_blank">
            Política de Privacidade
          </a>
          <a routerLink="/politica-de-cookies"
             (click)="scrollToTop()"
             class="text-center md:text-end text-gray-500 text-base font-normal font-['Inter']"
             target="_blank">
            Política de Cookies
          </a>
          <a routerLink="/politica-de-cancelamento-e-renovacao-automatica"
             (click)="scrollToTop()"
             class="text-center md:text-end text-gray-500 text-base font-normal font-['Inter']"
             target="_blank">
            Cancelamento e Renovação
          </a>
          <a routerLink="/aviso-lagal"
             (click)="scrollToTop()"
             class="text-center md:text-end text-gray-500 text-base font-normal font-['Inter']"
             target="_blank">
            Aviso Legal
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="py-15">
      <div class="flex justify-center">
        <a routerLink="/" (click)="scrollToTop()" aria-label="Ir para a página inicial">
          <img src="logo-casato-footer.svg"
               class="h-12"
               alt="Casato Logo"/>
        </a>
      </div>
      <div class="flex justify-center mt-4 text-gray-500 font-normal font-['Inter'] text-center">
         <p>© {{ currentYear }} Casato Brasil. Todos os direitos reservados.</p>
      </div>
      <div class="mx-auto mt-6 max-w-3xl px-6 text-center text-gray-500 font-normal font-['Inter']">
        <p>Este site utiliza cookies estritamente necessários para login, segurança, pagamentos e funcionamento da plataforma. Ao continuar navegando, você reconhece esse uso.</p>
      </div>
      <div class="flex justify-center items-center gap-4 mt-4">
        <a href="https://www.instagram.com/casatobrasil/"
           target="_blank"
           rel="noopener noreferrer"
           aria-label="Acessar Instagram da Casato Brasil">
        <svg class="w-6 h-6 text-gray-500"
             aria-hidden="true"
             xmlns="http://www.w3.org/2000/svg"
             width="24"
             height="24"
             fill="none"
             viewBox="0 0 24 24">
          <path fill="currentColor"
                fill-rule="evenodd"
                d="M3 8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8Zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H8Zm7.597 2.214a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z"
                clip-rule="evenodd"/>
        </svg>
        </a>
        <a href="https://wa.me/5511992448762"
           target="_blank"
           rel="noopener noreferrer"
           aria-label="Falar com a Casato Brasil pelo WhatsApp">
          <svg class="w-6 h-6 text-gray-500 hover:text-gray-400 transition"
               aria-hidden="true"
               xmlns="http://www.w3.org/2000/svg"
               width="24"
               height="24"
               fill="currentColor"
               viewBox="0 0 24 24">
            <path fill-rule="evenodd"
                  d="M12.04 3C7.08 3 3.05 6.96 3.05 11.83c0 1.55.41 3.06 1.2 4.39L3 21l4.92-1.24a9.15 9.15 0 0 0 4.12.99c4.96 0 8.99-3.96 8.99-8.83S17 3 12.04 3Zm0 15.94c-1.3 0-2.57-.34-3.68-.98l-.26-.15-2.92.74.75-2.79-.18-.29a6.97 6.97 0 0 1-1.08-3.64c0-3.87 3.3-7.02 7.37-7.02s7.37 3.15 7.37 7.02-3.3 7.11-7.37 7.11Zm4.04-5.25c-.22-.11-1.3-.63-1.5-.7-.2-.07-.35-.11-.5.11-.15.22-.57.7-.7.84-.13.15-.26.16-.48.05-.22-.11-.93-.34-1.77-1.08-.65-.58-1.09-1.29-1.22-1.51-.13-.22-.01-.34.1-.45.1-.1.22-.26.33-.39.11-.13.15-.22.22-.37.07-.15.04-.28-.02-.39-.05-.11-.5-1.18-.68-1.61-.18-.43-.36-.37-.5-.38h-.43c-.15 0-.39.05-.59.28-.2.22-.77.74-.77 1.8s.79 2.09.9 2.23c.11.15 1.55 2.33 3.75 3.26.52.22.93.35 1.25.45.52.16 1 .14 1.38.08.42-.06 1.3-.52 1.48-1.02.18-.5.18-.93.13-1.02-.05-.09-.2-.14-.42-.25Z"
                  clip-rule="evenodd"/>
          </svg>
        </a>
      </div>
  </div>
</footer>
